// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.guide-lead[data-v-571651da]{font-size:1.1rem;line-height:1.7;color:#334155}.guide-example[data-v-571651da]{margin:8px 0;padding:10px 14px;background:#f8fafc;border-left:3px solid #6366f1;border-radius:0 6px 6px 0;color:#334155;line-height:1.55}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
